import { deleteMode, getModes, saveMode, updateMode } from '@/services/community/wikigamer/games/modes'
export default {
	namespaced: true,
	state: {
		modeList: {
			meta: {
				total: 0,
			},
		},

		modeStatus: 'pending',
	},
	getters: {
		getModeList(state) {
			return state.modeList
		},
		getModeStatus(state) {
			return state.modeStatus
		},
	},
	mutations: {
		SET_MODE_LIST(state, value) {
			state.modeList = value
		},
		SET_MODE_STATUS(state, value) {
			state.modeStatus = value
		},
	},
	actions: {
		async fetchModes({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SET_MODE_STATUS', 'pending')
			commit('SET_MODE_LIST', {
				meta: {
					total: 0,
				},
			})
			try {
				const { data } = await getModes(params)
				commit('SET_MODE_STATUS', 'init')
				commit('SET_MODE_LIST', data)
				return data
			} catch (error) {
				commit('SET_MODE_STATUS', 'init')
				throw error
			}
		},
		async deleteModeRecord({ commit }, params) {
			commit('SET_MODE_STATUS', 'pending')
			try {
				const { data } = await deleteMode(params)
				commit('SET_MODE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_MODE_STATUS', 'init')
				throw error
			}
		},
		async saveMode({ commit }, params) {
			commit('SET_MODE_STATUS', 'pending')
			try {
				const { data } = await saveMode(params)
				commit('SET_MODE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_MODE_STATUS', 'init')
				throw error
			}
		},
		async updateMode({ commit }, params) {
			commit('SET_MODE_STATUS', 'pending')
			try {
				const { data } = await updateMode(params)
				commit('SET_MODE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_MODE_STATUS', 'init')
				throw error
			}
		},
	},
}
